export default "__VITE_ASSET__YTY1cvSB__"